import { render, staticRenderFns } from "./RoleManager.vue?vue&type=template&id=375cb554&scoped=true"
import script from "./RoleManager.vue?vue&type=script&lang=js"
export * from "./RoleManager.vue?vue&type=script&lang=js"
import style0 from "./RoleManager.vue?vue&type=style&index=0&id=375cb554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375cb554",
  null
  
)

export default component.exports